/**
 * Creates a Basic Authentication header
 */
export function createBasicAuthHeader(username: string, password: string): string {
  const base64Credentials = btoa(`${username}:${password}`)
  return `Basic ${base64Credentials}`
}

/**
 * Creates standard auth headers for restaurant API calls
 */
export function createAuthHeaders(restaurantId: string, key: string): Record<string, string> {
  return {
    'Authorization': createBasicAuthHeader(restaurantId, key),
    'Content-Type': 'application/json'
  }
}

/**
 * Creates headers for GET requests (no content-type needed)
 */
export function createGetHeaders(restaurantId: string, key: string): Record<string, string> {
  return {
    'Authorization': createBasicAuthHeader(restaurantId, key)
  }
}